import { defineComponent as _defineComponent } from 'vue'

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    TableCellCertificationLastAction: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'TableCellCertificationLastAction' };

import { computed } from '@vue';

import { dateFilter } from '@filters/date';
import type { Certification } from '@models';

/**
 * `TableCellCertificationLastAction` component properties.
 */
export interface Props {
  /** ... */
  item: Certification;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
  /** ... */
  item: Certification;
};



const displayValue = computed(() => {
  const { item } = props;

  if (item.approvedAt) {
    return `Approved on ${formateDate(item.approvedAt)}`;
  }

  if (item.reattemptPromptAt) {
    return `Reattempt prompted on ${formateDate(item.reattemptPromptAt)}`;
  }

  if (item.deniedAt) {
    return `Denied on ${formateDate(item.deniedAt)}`;
  }

  return 'N/A';
});

/**
 * ...
 *
 * @param value ...
 * @returns ...
 */
function formateDate(value: string) {
  return dateFilter(value, 'MM/dd/yyyy').toString();
}

return { __sfc: true,props, displayValue, formateDate }
}

})